import React, {useContext, useRef, useState} from 'react'
import { Context } from '../../context/Context';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './login.css';
import ProgressBar from '../../components/progressbar/ProgressBar';
import Navbar from '../../components/navbar/Navbar';
import { Notify} from "notiflix";

function Login() {
    const userRef = useRef();
    const passwordRef = useRef();
    const {dispatch, isFetching} = useContext(Context);    
    const [isLoading, setIsLoading] = useState(true);
    const [loadingPerc, setloadingPerc] = useState(0);

    const api_uri = "https://mentorxfa.herokuapp.com/api";

    Notify.init({
        position: 'right-top'
    })

    const handleSubmit = async (e) =>{
        e.preventDefault();

        dispatch({type: "LOGIN_START"});
        try {
            const res = await axios.post(api_uri+"/auth/login", {
                username: userRef.current.value, 
                password: passwordRef.current.value
            },{
                onUploadProgress: progressEvent => {

                    let perCompleted = Math.floor((progressEvent.loaded / progressEvent.total) *100 )
                    setloadingPerc(perCompleted);
                }
            })
            setTimeout(() => {
                setIsLoading(false)            
            }, 300)
            setTimeout(() => {
                dispatch({type: "LOGIN_SUCCESS", payload: res.data});             
            }, 500)

            
        } catch (err) {
            dispatch({type: "LOGIN_FAILURE"});      
            Notify.failure('Incorrect username or password');      
        }
    };

    return (    
        <>
        <Navbar/> 
        {
            isLoading && <ProgressBar percentage={loadingPerc}/>
        } 
         
        <div className="login">
            <div className="login-wrapper">
                <h2 className="login-title">Sign In</h2>
                <p className="login-desc"> Unlock useful features by signing in. </p>           
                <form action="" className="login-form" onSubmit={handleSubmit}>
                    <input type="text" className="login-form-input" required ref={userRef} placeholder="Enter Username"/>
                    <input type="password" className="login-form-input" required ref={passwordRef} placeholder="Enter Password" />
                    <button className="login-form-btn" disabled={isFetching}>Login</button>
                </form>                  
                <Link to="/register" className="link-login" ><span className="login-register-btn">Sign Up</span></Link>                
            </div>
        </div>  
        </> 
    )
}

export default Login
